import { IconProps } from "./";
import Icon from "./assets/plus_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Plus(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
